"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooManyAttempts = void 0;
const ApiException_1 = require("./ApiException");
class TooManyAttempts extends ApiException_1.ApiException {
    constructor(message = 'Too many attempts.', data) {
        super(message, data);
    }
}
exports.TooManyAttempts = TooManyAttempts;
